<template>
  <el-submenu :index="taskId">
    <template slot="title">{{ topTitle }}</template>
    <el-menu-item :index="`${taskId}-${scanType}-${item.value}`" v-for="(item,idx) in rfidConfig.allPackageTypes"
                  :key="idx"
                  :disabled="disabled"
    >{{ item.label }}
    </el-menu-item>
  </el-submenu>
</template>

<script>
import RfidEditConfig from "@/views/rfid/RfidEditConfig";

export default {
  props: ['topTitle', 'taskId', 'scanType', 'deviceStatus', 'disabled'],
  name: "RfidMenuItem",
  data() {
    return {
      rfidConfig: RfidEditConfig
    }
  }
}
</script>

<style scoped>

</style>
